import { useUserStore } from '@/stores/user'

export const authMiddleware = (to, from, next) => {
    const { isAuthenticated, isVerified } = useUserStore()


    if (!isAuthenticated) {
        return next({ name: 'login' })
    }

    // if (!isVerified) {
    //     return next({ name: 'account-verification' })
    // }

    return next()
}
